<template>
    <div class="page-container">
        <!-- 加载状态 -->
        <div v-if="isInitialLoading" class="loading-overlay">
            <div class="loading-content">
                <div class="loading-spinner"></div>
                <div class="loading-text">数据正在加载中...</div>
            </div>
        </div>

        <!-- 主要内容 -->
        <div v-else class="main-content">
            <!-- 顶部导航 -->
            <div class="header">
                <div @click="goBack" class="back-btn">
                    <van-icon name="arrow-left" color="#fff" size="20px" />
                </div>
                <div class="header-title">{{ lotteryDetails.name || '教育类' }}</div>
            </div>

            <!-- 信息卡片 -->
            <div class="info-card">
                <div class="info-left">
                    <div class="info-item">货币: {{ money }}</div>
                    <div class="info-item">轮数:{{ issueNewNumber }}</div>
                    <div class="info-item">截止时间: {{ countdownTime }}</div>
                </div>
                <div class="info-right" @click="goToBetRecord">交易记录</div>
            </div>

            <!-- 结果区域 -->
            <div class="result-section" @click="showResultDialog">
                <div class="result-text">{{ issueOldNumber }}匹配结果</div>
                <div class="result-status">{{ lotteryDetails.issue_old?.results || '' }}</div>
            </div>

            <!-- 按钮区域 -->
            <div class="buttons-section">
                <div class="buttons-grid">
                                    
                    <button @click="btnData[0] = !btnData[0]" :class="btnData[0] ? 'btnChoose' : ''" class="btn">做高</button>
                    <button @click="btnData[1] = !btnData[1]" :class="btnData[1] ? 'btnChoose' : ''" class="btn">做低</button>
                    <button @click="btnData[2] = !btnData[2]" :class="btnData[2] ? 'btnChoose' : ''" class="btn">做多</button>
                    <button @click="btnData[3] = !btnData[3]" :class="btnData[3] ? 'btnChoose' : ''" class="btn">做空</button>

                </div>
            </div>

            <div v-if="num > 0" class="bottom-input" role="region" aria-label="交易输入">
                <div class="bi-field">
                    <input
                      v-model="inputValue"
                      type="number"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      min="0"
                      placeholder="请输入"
                      :disabled="isTradeDisabled"
                    />
                </div>
                <div class="bi-balance">
                    <div class="bi-balance-title">余额</div>
                    <div class="bi-balance-amount">{{ money }}</div>
                </div>
            </div>

            <!-- 底部操作栏 -->
            <div class="bottom-bar">
                <button class="clear-btn" @click="cliear" style="margin-left: 10px;">清除</button>
                <div style="flex: 1;">
                    <div class="stats">
                        <div class="stat-item">
                            <span>共</span>
                            <span class="stat-number zero">{{ num }}</span>
                            <span>件</span>
                        </div>
                        <div class="stat-item">
                            <span>余额</span>
                            <span class="stat-number">{{ money }}</span>
                        </div>
                    </div>
                    <div class="stat-item" style="margin-top: 5px;">
                        <span>合计</span>
                        <span class="stat-number">¥{{ (inputValue || 0) * num }}</span>
                    </div>
                </div>
                <button class="trade-btn" @click="submit" :disabled="isDataLoading || isTradeDisabled">
                    {{ isDataLoading ? '数据更新中...' : (isTradeDisabled ? '交易已截止' : '交易') }}
                </button>
            </div>

            <!-- 交易确认弹窗 -->
            <div v-if="showConfirmDialog" class="confirm-overlay" @click="closeConfirmDialog">
                <div class="confirm-dialog" @click.stop>
                    <div class="confirm-header">购单确认</div>
                    <div class="confirm-content">
                        <div class="confirm-item">
                            <span class="confirm-label">当前期数：</span>
                            <span class="confirm-value">{{ issueNewNumber }}</span>
                        </div>
                        <div class="confirm-item">
                            <span class="confirm-label">购单金额：</span>
                            <span class="confirm-value">{{ inputValue }}</span>
                        </div>
                        <div class="confirm-item">
                            <span class="confirm-label">购单内容：</span>
                            <span class="confirm-value">{{ getSelectedPlayMethods() }}</span>
                        </div>
                    </div>
                    <div class="confirm-buttons">
                        <button class="cancel-btn" @click="closeConfirmDialog">取消</button>
                        <button class="confirm-btn" @click="confirmTrade" :disabled="isTradeDisabled">
                            {{ isTradeDisabled ? '交易已截止' : '确认下单' }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- 结果弹窗 -->
            <div v-if="showResultPopup" class="result-overlay" @click="closeResultDialog">
                <div class="result-popup" @click.stop>
                    <div class="result-popup-header">
                        <span>往期匹配结果</span>
                        <button class="close-btn" @click="closeResultDialog">×</button>
                    </div>
                    <div class="result-popup-content">
                        <div class="result-list">
                            <div class="result-list-header">
                                <div class="header-col">期数</div>
                                <div class="header-col">做高/做低</div>
                                <div class="header-col">做多/做空</div>
                            </div>
                            <!-- 使用真实的历史数据 -->
                            <div v-if="historyData.length === 0" class="no-data">
                                <div class="no-data-text">暂无历史数据</div>
                            </div>
                            <div v-else v-for="item in historyData" :key="item.issue" class="result-item">
                                <div class="result-col">{{ item.issue }}</div>
                                <div class="result-col" :class="{
                                    'result-high': parseResult(item.result).highLow === '做高',
                                    'result-low': parseResult(item.result).highLow === '做低'
                                }">
                                    {{ parseResult(item.result).highLow }}
                                </div>
                                <div class="result-col" :class="{
                                    'result-long': parseResult(item.result).longShort === '做多',
                                    'result-short': parseResult(item.result).longShort === '做空'
                                }">
                                    {{ parseResult(item.result).longShort }}
                                </div>
                            </div>
                        </div>
                        <div class="more-btn">更多</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed,onBeforeUnmount } from 'vue';
import { onMounted } from 'vue';
import homeApi from "@/api/home";
import userApi from "@/api/user";
import { useRoute, useRouter } from 'vue-router'
import { Toast } from 'vant';
import { Icon as VanIcon } from 'vant';
import { handleUnauthorizedError } from "@/utils/auth";

const router = useRouter()
const route = useRoute()

onMounted(async () => {
    try {
        // 从路由参数获取游戏ID
        const gameId = route.query.id
        if (!gameId) {
            Toast.fail('参数错误')
            router.push('/lottery')
            return
        }

        // 并行获取用户余额和彩票详情
        await Promise.all([
            getUserMoney(),
            getLotteryDetails(gameId)
        ])

        // 启动倒计时（每秒更新显示）
        timer = setInterval(()=>{
            updateCountdown()
        }, 1000)

        // 注意：不再启动余额定时更新，只在第一次加载时获取
        
    } catch (error) {
        console.error('页面初始化失败:', error)
        Toast.fail('页面加载失败')
    } finally {
        // 数据加载完成，隐藏加载状态
        isInitialLoading.value = false
    }
})
let timer

// 获取用户余额
const getUserMoney = async () => {
    try {
        const res = await userApi.money()
        console.log('获取余额:', res)
        
        // 检查返回的code是否为401，如果是则跳转到登录页
        if (handleUnauthorizedError(res)) {
            return
        }
        
        if (res.code === 1 && res.data && res.data.money !== undefined) {
            money.value = res.data.money
        } else if (res.code === 200 && res.data && res.data.money !== undefined) {
            money.value = res.data.money
        } else {
            console.error('获取余额接口返回异常:', res)
        }
    } catch (error) {
        console.error('获取余额失败:', error)
    }
}

onBeforeUnmount(() => {
    clearInterval(timer)
    console.log('清理定时器')
})

const btnData = ref([false, false, false, false])

const money = ref()
const inputValue = ref('')

// 弹窗相关
const showConfirmDialog = ref(false)
const showResultPopup = ref(false)

// 历史数据
const historyData = ref([])

// 彩票详情数据
const lotteryDetails = ref({})
const issueNewNumber = ref('0000')
const issueOldNumber = ref('')
const countdownTime = ref('00:00')
let countdownSeconds = 0 // 倒计时秒数

const isDataLoading = ref(false) // 数据加载状态
const isTradeDisabled = ref(false)
const isInitialLoading = ref(true) // 初始加载状态

const num = computed(() => {
    let i = 0
    btnData.value.map(item => {
        if (item) {
            i += 1
        }
    })
    return i
})

const goBack = () => {
    router.go(-1) // 后退一步
}

// 跳转到交易记录页面
const goToBetRecord = () => {
    router.push({
        path: '/jiaoyijilu'
    })
}



// 获取彩票详情
const getLotteryDetails = async (gameId, showLoading = true) => {
    try {
        if (showLoading) {
            isDataLoading.value = true
        }
        const res = await homeApi.LotteryDetails({ id: gameId })
        console.log('LotteryDetails:', res)
        
        // 检查接口返回状态码
        if (res.code !== 200) {
            Toast.fail(res.message || '获取数据失败')
            router.push('/lottery')
            return
        }
        
        if (res.data) {
            lotteryDetails.value = res.data

            // 提取 issue_new 的 issue_numb 作为轮数，只显示后四位
            const issueNewFull = res.data.issue_new?.issue_numb || ''
            issueNewNumber.value = issueNewFull.toString().slice(-4)

            // 提取 issue_old 的 issue_numb
            const issueOldFull = res.data.issue_old?.issue_numb || ''
            issueOldNumber.value = issueOldFull

            // 初始化倒计时（从 issue_new 的 end_time 开始）
            const endTime = res.data.issue_new?.end_time || 0
            const nowTime = res.ext?.now_time || Math.floor(Date.now() / 1000)
            const remainingSeconds = endTime - nowTime

            console.log('倒计时调试:', {
                endTime,
                nowTime,
                remainingSeconds,
                endTimeDate: new Date(endTime * 1000),
                nowTimeDate: new Date(nowTime * 1000)
            })

            // 提高容错性：如果剩余时间为负数或异常，使用默认的 180 秒
            if (remainingSeconds < 0 || remainingSeconds > 300 || isNaN(remainingSeconds)) {
                console.warn('倒计时数据异常，使用默认值180秒', { endTime, nowTime, remainingSeconds })
                countdownSeconds = 180
            } else {
                countdownSeconds = remainingSeconds
            }
            updateCountdown()
        }
    } catch (error) {
        console.error('获取彩票详情失败:', error)
        Toast.fail('获取数据失败')
        router.push('/lottery')
    } finally {
        if (showLoading) {
            isDataLoading.value = false
        }
    }
}

// 更新倒计时显示
const updateCountdown = async () => {
    const minutes = Math.floor(countdownSeconds / 60)
    const seconds = countdownSeconds % 60
    countdownTime.value = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`

    if (countdownSeconds > 0) {
        // 剩余5秒时禁用交易按钮
        isTradeDisabled.value = countdownSeconds <= 5
        countdownSeconds--
    } else {
        // 倒计时结束，重新请求数据更新期号（不显示加载状态，不禁用交易按钮）
        countdownTime.value = '00:00'
        try {
            const gameId = route.query.id
            if (gameId) {
                await getLotteryDetails(gameId, false)
            }
        } catch (error) {
            console.error('倒计时结束后获取彩票详情失败:', error)
            // 如果请求失败，设置默认倒计时180秒
            countdownSeconds = 180
        }
    }
}



const cliear = () => {
    inputValue.value = ''
    btnData.value = [false, false, false, false]
}

// 防止重复提交
let isSubmitting = false

const submit = async () => {
    // 检查数据是否正在加载中
    if (isDataLoading.value) {
        Toast.fail('数据更新中，请稍候...')
        return
    }

    // 检查是否禁用交易
    if (isTradeDisabled.value) {
        Toast.fail('交易已截止')
        return
    }

    // 验证是否选择了玩法
    if (num.value === 0) {
        Toast.fail('请选择玩法')
        return
    }

    // 验证是否输入了金额
    if (!inputValue.value || inputValue.value <= 0) {
        Toast.fail('请输入有效的金额')
        return
    }

    // 验证余额是否充足
    const totalAmount = inputValue.value * num.value
    if (money.value < totalAmount) {
        Toast.fail('余额不足')
        return
    }

    // 验证期号是否有效
    if (!lotteryDetails.value.issue_new?.issue_numb) {
        Toast.fail('期号数据异常，请刷新页面重试')
        return
    }

    // 显示确认弹窗
    showConfirmDialog.value = true
}

// 确认交易
const confirmTrade = async () => {
    // 检查数据是否正在加载中
    if (isDataLoading.value) {
        Toast.fail('数据更新中，请稍候...')
        return
    }

    // 再次验证期号是否有效
    if (!lotteryDetails.value.issue_new?.issue_numb) {
        Toast.fail('期号数据异常，请刷新页面重试')
        closeConfirmDialog()
        return
    }

    // 防止重复提交
    if (isSubmitting) {
        Toast.fail('正在处理中，请稍候...')
        return
    }
    isSubmitting = true
    
    try {

        // 获取选中的玩法 ID（做高=1, 做低=2, 做多=3, 做空=4）
        const playTypeIds = []
        if (btnData.value[0]) playTypeIds.push(1)  // 做高
        if (btnData.value[1]) playTypeIds.push(2)  // 做低
        if (btnData.value[2]) playTypeIds.push(3)  // 做多
        if (btnData.value[3]) playTypeIds.push(4)  // 做空

        // 构造下注数据，根据新的接口文档格式
        const data = {
            issue: lotteryDetails.value.issue_new?.issue_numb,
            game_id: parseInt(route.query.id),
            money: parseFloat(inputValue.value),
            bet_content: playTypeIds.join(',')
        }
        
        console.log('下注数据:', data)
        const res = await homeApi.playOrder(data)
        if (res.code !== 1) {
            Toast.fail(res.msg || '下注失败')
            return
        }

        Toast.success('交易成功')
        // 使用返回数据中的after_quantity更新余额
        if (res.data && res.data.after_quantity !== undefined) {
            money.value = res.data.after_quantity
            console.log('余额已更新为:', money.value)
        }

        // 清除选择
        cliear()
        
        // 关闭弹窗
        showConfirmDialog.value = false
    } catch (error) {
        console.error('下注错误:', error)
        Toast.fail('下注失败，请重试')
    } finally {
        // 重置提交标志
        isSubmitting = false
    }
}

// 关闭确认弹窗
const closeConfirmDialog = () => {
    showConfirmDialog.value = false
}

// 获取选中的玩法文本
const getSelectedPlayMethods = () => {
    const methods = []
    if (btnData.value[0]) methods.push('做高')  // btnData[0] = 做高
    if (btnData.value[1]) methods.push('做低')  // btnData[1] = 做低
    if (btnData.value[2]) methods.push('做多')  // btnData[2] = 做多
    if (btnData.value[3]) methods.push('做空')  // btnData[3] = 做空
    return methods.join('，')
}

// 解析结果字符串
const parseResult = (resultString) => {
    if (!resultString) return { highLow: '未知', longShort: '未知' }
    
    const results = resultString.split(',').map(item => item.trim())
    let highLow = '未知'
    let longShort = '未知'
    
    results.forEach(result => {
        if (result === '做高' || result === '做低') {
            highLow = result
        } else if (result === '做多' || result === '做空') {
            longShort = result
        }
    })
    
    return { highLow, longShort }
}

// 获取历史数据
const getHistoryData = async () => {
    try {
        // 从路由参数获取游戏ID
        const gameId = route.query.id
        if (!gameId) {
            console.error('缺少游戏ID参数')
            return
        }
        
        const res = await homeApi.lishi(gameId)
        console.log('历史数据:', res)
        if (res.code === 1 && res.data) {
            historyData.value = res.data
        }
    } catch (error) {
        console.error('获取历史数据失败:', error)
    }
}

// 显示结果弹窗
const showResultDialog = async () => {
    showResultPopup.value = true
    // 显示弹窗时获取历史数据
    await getHistoryData()
}

// 关闭结果弹窗
const closeResultDialog = () => {
    showResultPopup.value = false
}
</script>

<style scoped>
/* 页面容器 */
.page-container {
    min-height: 100vh;
    background-color: #1a1f36;
    color: #ffffff;
}

/* 主内容区域 */
.main-content {
    width: 100%;
    max-width: 447px;
    margin: 0 auto;
    position: relative;
    background-color: #1a1f36;
    padding-bottom: 120px; /* 为固定的输入区域和底部操作栏留出空间 */
    padding-bottom: calc(120px + constant(safe-area-inset-bottom));
    padding-bottom: calc(120px + env(safe-area-inset-bottom));
}

/* PC端适配 */
@media (min-width: 769px) {
    .page-container {
        display: flex;
        justify-content: center;
        background-color: #f5f5f5;
        padding: 0;
    }
    
    .main-content {
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        overflow: hidden;
    }
}

/* 顶部导航栏 */
.header {
    background-color: #000000;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.back-btn {
    position: absolute;
    left: 16px;
    font-size: 24px;
    color: #ffffff;
    cursor: pointer;
}

.header-title {
    font-size: 18px;
    font-weight: 500;
}

/* 信息卡片 */
.info-card {
    background-color: #32395e;
    margin: 0;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 15px;
}

.info-left {
    flex: 1;
}

.info-item {
    font-size: .37rem;
    color: #cbcbd6;
    /* margin-bottom: 6px; */
    text-align: justify;
    line-height: 1.5;
}

.info-item:last-child {
    margin-bottom: 0;
}

.info-right {
    font-size: 14px;
    color: #d0d5e0;
}

/* 结果区域 */
.result-section {
    padding: 16px 20px;
    background-color: #32395e;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.result-text {
    font-size: 15px;
    color: #d0d5e0;
}

.result-status {
    font-size: 14px;
    color: #d0d5e0;
}

/* 按钮区域 */
.buttons-section {
    padding: 20px;
    background-color: #1a1f36;
}

.buttons-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    max-width: 400px;
    margin: 0 auto;
}

.btn {
    background-color: #ffffff;
    color: #000000;
    border: none;
    border-radius: 10px;
    padding: 18px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
}

.btn:active {
    transform: scale(0.98);
    opacity: 0.9;
}

/* 底部操作栏 */
.bottom-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 447px;
    margin: 0 auto;
    background: #333333;
    display: flex;
    align-items: center;
    /* padding: 0 16px; */
    height: 60px;
    z-index: 8; /* 低于输入栏，避免遮挡 */
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    will-change: auto;
}

/* PC端适应内容宽度 */
@media (min-width: 769px) {
    .bottom-bar {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        max-width: none;
        transform: none;
    }
    
    .bottom-input {
        position: absolute;
        bottom: 60px;
        left: 0;
        right: 0;
        max-width: 447px;
        width: 447px;
        margin: 0 auto;
    }
}

.btnChoose {
    background-color: #0ea2ff;
    color: white;
}

.bottom-input {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 60px;
    bottom: calc(60px + constant(safe-area-inset-bottom));
    bottom: calc(60px + env(safe-area-inset-bottom));
    width: 100%;
    max-width: 447px;
    margin: 0 auto;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
    box-sizing: border-box;
    z-index: 10;
    border-top: 1px solid rgba(0,0,0,0.06);
    box-shadow: 0 -2px 8px rgba(0,0,0,0.08);
}

.bottom-input .bi-field input {
    width: 160px;
    height: 40px;
    border-radius: 10px;
    border: 2px solid #c57486;
    font-size: 16px;
    color: #000000;
    background-color: #ffffff;
    box-sizing: border-box;
    padding: 0 12px;
    outline: none;
    -webkit-appearance: none;
    appearance: none;
    touch-action: manipulation;
}

.bottom-input .bi-balance {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #000000;
}

.bottom-input .bi-balance-title {
    font-size: 14px;
    line-height: 1.4;
}

.bottom-input .bi-balance-amount {
    font-size: 22px;
    color: #ff9e9c;
    font-weight: 600;
}

/* 去除数字输入的上下微调按钮，保证高度一致 */
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type='number'] {
    -moz-appearance: textfield;
}

.stats {
    display: flex;
    gap: 16px;
    font-size: 16px;
    /* color: #d0d5e0; */
    flex-wrap: nowrap;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 16px;
}

.stat-number {
    color: #ff6b6b;
}

.stat-number.zero {
    color: #d0d5e0;
}

.clear-btn {
    /* background-color: #3a3e4a; */
    color: #ffffff;
    border: .05333rem solid #c5c5c5;
    border-radius: 20px;
    padding: 12px 12px;
    font-size: 15px;
    cursor: pointer;
    margin-right: 12px;
    flex-shrink: 0;
    margin-left: 10px; /* 确保离左边界10px */
}

.trade-btn {
    background: linear-gradient(135deg, #ff6b8a 0%, #ff8fa3 100%);
    color: #ffffff;
    border: none;
    /* border-radius: 8px; */
    padding: 0 32px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.trade-btn:disabled {
    background: #cccccc;
    cursor: not-allowed;
    opacity: 0.6;
}

.submit-btn {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.submit-btn:hover {
    background-color: #0056b3;
}

.submit-btn:disabled,
.submit-btn.disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.submit-btn:disabled:hover,
.submit-btn.disabled:hover {
    background-color: #6c757d;
}

/* 响应式 */
@media (max-width: 480px) {
    .btn {
        padding: 8px;
        font-size: 20px;
    }
}

/* 结果弹窗样式 */
.result-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.result-popup {
    background-color: #32395e;
    border-radius: 12px;
    width: 90%;
    height: calc(100vh - 120px); /* 从顶部导航下方到底部操作栏上方 */
    margin-top: 60px; /* 顶部导航高度 */
    margin-bottom: 60px; /* 底部操作栏高度 */
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.result-popup-header {
    background-color: #2a2f4a;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #3a3f5a;
    flex-shrink: 0;
}

.result-popup-header span {
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
}

.close-btn {
    background: none;
    border: none;
    color: #ffffff;
    font-size: 24px;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.result-popup-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.result-list {
    flex: 1;
    overflow-y: auto;
    padding: 0 20px;
}

.result-list-header {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    padding: 16px 0;
    border-bottom: 1px solid #3a3f5a;
    position: sticky;
    top: 0;
    background-color: #32395e;
    z-index: 1;
}

.header-col {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
}

.result-item {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    padding: 12px 0;
    border-bottom: 1px solid #3a3f5a;
}

.result-col {
    font-size: 14px;
    color: #cbcbd6;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.result-high {
    color: #ff6b6b !important;
}

.result-low {
    color: #4ecdc4 !important;
}

.result-long {
    color: #45b7d1 !important;
}

.result-short {
    color: #f9ca24 !important;
}

.more-btn {
    padding: 16px 20px;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
    border-top: 1px solid #3a3f5a;
    background-color: #2a2f4a;
    flex-shrink: 0;
}

.more-btn:hover {
    background-color: #3a3f5a;
}

.no-data {
    padding: 40px 20px;
    text-align: center;
}

.no-data-text {
    font-size: 16px;
    color: #cbcbd6;
}

/* PC端适应 */
@media (min-width: 769px) {
    .result-overlay {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 447px;
        height: 100%;
    }
    
    .result-popup {
        width: 100%;
        max-width: none;
        height: calc(100vh - 120px);
        margin-top: 60px;
        margin-bottom: 60px;
        transform: none;
        left: auto;
    }
}

/* 确认弹窗样式 */
.confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.confirm-dialog {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 24px;
    margin: 20px;
    max-width: 320px;
    width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.confirm-header {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
}

.confirm-content {
    margin-bottom: 24px;
}

.confirm-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding: 8px 0;
}

.confirm-label {
    font-size: 14px;
    color: #666666;
    font-weight: 500;
}

.confirm-value {
    font-size: 14px;
    color: #333333;
    font-weight: bold;
}

.confirm-buttons {
    display: flex;
    gap: 12px;
}

.cancel-btn, .confirm-btn {
    flex: 1;
    padding: 12px 0;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
}

.cancel-btn {
    background-color: #f5f5f5;
    color: #666666;
}

.cancel-btn:hover {
    background-color: #e8e8e8;
}

.confirm-btn {
    background-color: #007aff;
    color: #ffffff;
}

.confirm-btn:hover {
    background-color: #0056cc;
}

.confirm-btn:active {
    transform: scale(0.98);
}

.cancel-btn:active {
    transform: scale(0.98);
}

/* 确认弹窗PC端适配 */
@media (min-width: 769px) {
    .confirm-overlay {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 447px;
        height: 100%;
    }
    
    .confirm-dialog {
        max-width: 350px;
        width: 80%;
    }
}
</style>